import React from 'react';
import { useNavigate } from 'react-router-dom';

// Detekce iOS PWA – true JEN na iPhonu/iPadu přidaném na plochu
const isIOSPWA = window.navigator.standalone === true;

/**
 * Jednotná hlavička pro všechny komponenty
 * @param {string} title - Hlavní nadpis stránky
 * @param {string} subtitle - Podnadpis (volitelné)
 * @param {React.ReactNode} actions - Akční tlačítka vpravo (volitelné)
 * @param {boolean} showBackButton - Zobrazit tlačítko zpět (výchozí: true)
 * @param {string} backText - Text tlačítka zpět (výchozí: "Zpět na seznam firem")
 * @param {string} backPath - Cesta pro zpět (výchozí: "/")
 * @param {function} onBack - Vlastní callback pro tlačítko zpět (volitelné)
 */
export default function PageHeader({ 
  title, 
  subtitle, 
  actions, 
  showBackButton = true,
  backText = "Zpět na seznam firem",
  backPath = "/",
  onBack
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(backPath);
    }
  };

  return (
    <div className="mb-6" style={{ paddingTop: isIOSPWA ? 'env(safe-area-inset-top)' : undefined }}>
      {/* Řádek 1 - tlačítko zpět + title */}
      <div className="flex items-center gap-4 mb-3">
        {showBackButton && (
          <button
            onClick={handleBack}
            className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 hover:bg-blue-200 text-blue-700 dark:bg-blue-800 dark:hover:bg-blue-700 dark:text-white rounded-lg shadow-md transition font-semibold flex-shrink-0"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            {backText}
          </button>
        )}
        <h1 className="text-3xl font-bold text-gray-800 dark:text-white">
          {title}
        </h1>
      </div>

      {/* Řádek 2 - akční tlačítka */}
      {actions && (
        <div className="flex gap-2 flex-wrap">
          {actions}
        </div>
      )}

      {/* Subtitle */}
      {subtitle && (
        <p className="text-gray-600 dark:text-gray-400 mt-2">
          {subtitle}
        </p>
      )}
    </div>
  );
}
